<template>
    <div class="archive">
        <Bread :title1="'Личный кабинет'" :title2="'Архив заказов'"/>  
        <div class="archive__title">
            <p>Архив заказов</p>
        </div>
        <div class="archive__orders" v-if="Object.keys(groupedOrders).length > 0">
            <div class="archive__order-group" v-for="(group, orderId) in groupedOrders" :key="orderId">
                <div class="archive__order-group__header">
                    <p>Заказ №{{ orderId }}</p>
                    <p class="archive__order-group__status archived">
                        Получен
                    </p>
                </div>
                <div class="archive__order-group__items">
                    <div class="archive__products__in" v-for="item in group" :key="item.id">
                        <img :src="item.image" class="archive__products__in__img" />
                        <p class="archive__products__in__title">{{ item.product_title || item.title }}</p>
                        <p>Артикул: {{ item.vendor_code }}</p>
                        <div class="archive__products__in__1">
                            <p>В наличии</p>
                            <img src="@/assets/icons/ok.svg" />
                        </div>
                        <p class="archive__products__in__price">{{ formatPrice(item.price) }}</p>
                        <div class="archive__products__in__bot">
                            <p>Товар получен</p>
                        </div>
                    </div>
                </div>
                <div class="archive__order-group__footer">
                    <p>Итого: {{ formatPrice(calculateOrderTotal(group)) }}</p>
                </div>
            </div>
        </div> 
        <div class="archive__not" v-else>
            <p>У вас нет товаров в архиве</p>
        </div>
    </div>
</template>

<script>
import Bread from './Bread.vue';
import CardProductVue from './CardProduct.vue';

export default {
    data() {
        return {
            newArchive: [],
            products: [],
        }
    },
    components: {
        Bread, 
        CardProductVue 
    },
    computed: {
        groupedOrders() {
            if (!this.newArchive || this.newArchive.length === 0) return {};
            
            const groups = {};
            this.newArchive.forEach(item => {
                if (!groups[item.order_id]) {
                    groups[item.order_id] = [];
                }
                groups[item.order_id].push(item);
            });
            return groups;
        }
    },
    async created() {
        this.getPage();    
    },
    methods: {
        async getPage() {    
            await this.$axios.get(`orders/approved`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.newArchive = res.data.orderProducts.data;
            })
            .catch(err => {
                console.error(err);
            });        
        },
        formatPrice(price) {
            const number = parseFloat(price);
            if (isNaN(number)) return 'Цена не указана';
            return number.toLocaleString('ru-RU') + ' ₸';
        },
        calculateOrderTotal(items) {
            return items.reduce((total, item) => total + parseFloat(item.price), 0);
        }
    }
}
</script>

<style lang="scss" scoped>
    .archive{
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 1.3021))), 30px);
        
        &__title{
            color: #363636;
            font-size: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.7813))), 24px);
            @media(max-width:768px){
                font-size: 15px;
            }
        }
        
        &__not{
            font-size: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 0.5208))), 18px);
            @media(max-width:768px){
                font-size: 14px;
            }
        }
        
        &__order-group {
            border: 1px solid #e0e0e0;
            border-radius: 10px;
            padding: 20px;
            margin-bottom: 30px;
            background: #f9f9f9;
            
            &__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 1px solid #e0e0e0;
                
                p {
                    font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    font-weight: bold;
                    color: #363636;
                }
                
                &__status {
                    padding: 5px 10px;
                    border-radius: 5px;
                    font-size: 14px;
                    
                    &.archived {
                        background: #f0f0f0;
                        color: #666;
                    }
                }
            }
            
            &__items {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(min(max(150px, calc(9.375rem + ((1vw - 7.68px) * 8.6806))), 250px), 1fr));
                gap: min(max(30px, calc(1.875rem + ((1vw - 7.68px) * 2.6042))), 60px);
                row-gap: min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
            }
            
            &__footer {
                margin-top: 20px;
                padding-top: 10px;
                border-top: 1px solid #e0e0e0;
                text-align: right;
                font-weight: bold;
                font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.5208))), 20px);
            }
        }
        
        &__products__in{
            border: 1px solid #0000001A;
            border-radius: 10px;
            padding: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 1.0417))), 24px);
            display: flex;
            flex-direction: column;
            gap: min(max(7px, calc(0.4375rem + ((1vw - 7.68px) * 0.434))), 12px);
            font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.5208))), 15px);
            color: #00000080;
            cursor: pointer;
            transition: all 0.5s ease;
            background: white;
            
            @media(max-width:768px){
                font-size: 13px;
            }
            
            &:hover{
                transform: scale(1.05);
            }
            
            &__img{
                width: 100%;
                aspect-ratio: 1;
            }
            
            &__title{
                color: #232F3E;
                flex-grow: 1;
            }
            
            &__1{
                display: flex;
                gap: 10px;
            }
            
            &__price{
                font-size: min(max(12px, calc(0.75rem + ((1vw - 7.68px) * 0.5208))), 18px) !important;
                color: black !important;
                @media(max-width:768px){
                    font-size: 13px !important;
                }
            }
            
            &__bot{
                display: flex;
                justify-content: center;
                align-items: center;
                color: green;
            }
        }
    }
</style>